/**
 * 任务下载功能
 */
import { ElMessage } from 'element-plus'
import { taskAPI } from '@/api/task'

export function useTaskDownload() {
    /**
     * 下载单个任务结果
     */
    const downloadTaskResults = async (taskId: string, format: 'zip' | 'json' = 'zip') => {
        try {
            // 直接使用 taskAPI 下载任务结果
            const result = await taskAPI.downloadTaskResults(taskId, format)

            if (format === 'zip' && result instanceof Blob) {
                // 创建下载链接
                const url = URL.createObjectURL(result)
                const link = document.createElement('a')
                link.href = url
                link.download = `task-${taskId}.zip`
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                URL.revokeObjectURL(url)
                ElMessage.success('任务结果下载已开始')
            } else {
                ElMessage.success('任务结果下载已开始')
            }
        } catch (err: any) {
            console.error('下载任务结果失败:', err)
            ElMessage.error(err.message || '下载任务结果失败')
            throw err
        }
    }

    /**
     * 批量下载任务结果
     */
    const batchDownloadTasks = async (taskIds: string[], _format: 'zip' | 'individual' = 'zip') => {
        try {
            for (const taskId of taskIds) {
                await downloadTaskResults(taskId, 'zip')
                // 添加延迟避免浏览器阻止多个下载
                if (taskIds.length > 1) {
                    await new Promise(resolve => setTimeout(resolve, 500))
                }
            }
            ElMessage.success(`开始下载 ${taskIds.length} 个任务的结果`)
        } catch (err: any) {
            ElMessage.error(err.message || '批量下载失败')
            throw err
        }
    }

    return {
        downloadTaskResults,
        batchDownloadTasks
    }
}
